module.exports = {"TXTCLI_Amount":{"id":"TXTCLI_Amount","defaultMessage":"Belopp","track":"Amount"}}